/* eslint-disable no-useless-escape */
/**
 * Convert given content URL-addresses to links.
 * @param {string} content element html content as string
 * @return {string} same as given content but URL-addresses replaced with <a> elements.
 */
function convertContentURLtoLinks( content ) {
  if( typeof content === 'string' ) {
    const regularExpression = /(\b(https?|):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    const elementContent = content.replace(regularExpression, '<a href=\'$1\'>$1</a>');

    const secondRegularExpression =/(^|[^\/])(www\.[\S]+(\b|$))/gim;
    return elementContent.replace( secondRegularExpression, '$1<a target="_blank" href="http://$2">$2</a>' );
  } else {
    return content;
  }
}

/**
 * Search whole DOM for elements's with class named '.url-to-links' by default.
 * Found elements innerHTML is runned trough convertContentURLtoLinks function.
 *
 * @param {string} selector default `.url-to-links`
 */
function searchAndReplaceDOM(selector='.url-to-links') {
  const elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    element.innerHTML = convertContentURLtoLinks( element.innerHTML );
  });
}

export default {
  convertContentURLtoLinks,
  searchAndReplaceDOM
};

export {
  convertContentURLtoLinks,
  searchAndReplaceDOM
};
